import { Injectable, Injector } from '@angular/core';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import {LoginService, StateStorageService} from '../../shared';
import {InactivityService} from '../../modals/inactivity-modal/inactivity.service';
import {tap} from 'rxjs/operators';

@Injectable()
export class AuthExpiredInterceptor implements HttpInterceptor {

    constructor(private injector: Injector,
                private stateStorageService: StateStorageService,
                private inactivityService: InactivityService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            tap((event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse) {
                        if (event.url && event.url.indexOf('api/remember-me') === -1 ) {
                            this.inactivityService.registerUserActivity();
                        }
                    }
                    return event;
                }, (error: any) => {
                    if (error.status === 401 &&
                        error.url &&
                        error.url.indexOf('/api/authentication') === -1 &&
                        error.url.indexOf('/api/account') === -1) {
                        this.stateStorageService.storePreviousState(this.stateStorageService.getDestinationState());
                        this.injector.get<LoginService>(LoginService).logout(); // NOSONAR
                    }
                    throw error;
                }
            )
        );
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/blocks/interceptor/auth-expired.interceptor.ts